// extracted by mini-css-extract-plugin
export default {"Container":"form_Container__1GbvL","FormGroup":"form_FormGroup__41Eig","Prompt":"form_Prompt__uQ3b3","submitButton":"form_submitButton__OnCdX","submitIcon":"form_submitIcon__CqiO9"};